import { Flex, Text, Box, chakra, Image } from "@chakra-ui/react";
import { useI18n } from "@/hooks/useI18n";
import { BXInput, BXButton } from "@/styles";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { toastTip } from "@/components/ui/toast";
import copyToClipboard from "copy-to-clipboard";
import { ipValid } from "@/utils/regexp";

const ItemBox = chakra(Flex, {
  baseStyle: {
    padding: "10px 15px 10px 20px",
    color: "#010313",
    fontSize: "14px",
    display: "flex",
    borderRadius: "12px",
    border: "1px solid  #E3E4F1",
    alignItems: "center",
    justifyContent: "space-between",
    bgColor: "rgba(32, 26, 85, 0.05)",
    svg: {
      marginLeft: "10px",
    },
  },
});

const ItemTitle = chakra(Text, {
  baseStyle: {
    color: "#010313",
    fontSize: "14px",
  },
});

const ItemText = chakra(Text, {
  baseStyle: {
    color: "#010313",
    fontSize: "14px",
  },
});

const CopyBox = chakra(Flex, {
  baseStyle: {
    ml: "10px",
    flexBasis: "27px",
    height: "27px",
    width: "27px",
    borderRadius: "6px",
    bgColor: "rgba(32, 26, 85, 0.05)",
    padding: "5px",
    _hover: {
      bgColor: "rgba(32, 26, 85, 0.1)",
    },
  },
});

const SecretKeyText = chakra(Text, {
  baseStyle: {
    color: "#D04457",
    fontSize: "14px",
    mt: "10px",
  },
});
const Space = chakra(Box, {
  baseStyle: {
    width: "100%",
    height: "40px",
  },
});

const Save = ({ ipAddressInputValue, setIpAddressInputValue }) => {
  const { t } = useI18n();
  const navigate = useNavigate();

  const clickCopy = (text) => {
    copyToClipboard(text);
    toastTip(t("gXbirwakdsaUKBglwK"), { type: "success" });
  };

  const btnDisabled = useMemo(() => {
    if (!ipAddressInputValue) {
      return true;
    } else {
      if (ipAddressInputValue && ipAddressInputValue.includes(";")) {
        let flag = false;
        const ipArr = ipAddressInputValue.split(",");
        for (let i = 0; i < ipArr.length; i++) {
          if (!ipValid(ipArr[i])) {
            flag = true;
            break;
          }
        }
        return flag;
      } else {
        if (!ipValid(ipAddressInputValue)) {
          return true;
        }
        return false;
      }
    }
  }, [ipAddressInputValue]);

  const MOCK_SUBACCOUNT = [
    {
      label: "mock1",
      value: 1,
    },

    {
      label: "mock2",
      value: 2,
    },
  ];

  return (
    <Flex
      alignItems={"center"}
      flexDirection={"column"}
      w={["90%", "500px"]}
      justifyContent={"flex-start"}
      margin={"0 auto"}
    >
      <Text fontSize={"24px"} fontWeight={600}>
        {t("API信息")}
      </Text>

      {/* API KEY */}
      <Box mt="20px" w={"100%"}>
        <ItemTitle>Api Key</ItemTitle>
        <ItemBox mt={"10px"}>
          <ItemText w={"90%"}>
            evXPcpwd2FpVPi7jqZDTk8pcUtdwKWspSRaDkoUAUZTLaL3qL3ozMIG0QBR2ASXB
          </ItemText>
          <CopyBox>
            <Image
              src="../../../wwwsite/images/copy.svg"
              cursor={"pointer"}
              onClick={() => {
                clickCopy("21");
              }}
            />
          </CopyBox>
        </ItemBox>
      </Box>
      <Space />
      {/* Secret KEY */}
      <Box w={"100%"}>
        <ItemTitle>Secret Key</ItemTitle>
        <ItemBox mt={"10px"}>
          <ItemText w={"90%"}>
            evXPcpwd2FpVPi7jqZDTk8pcUtdwKWspSRaDkoUAUZTLaL3qL3ozMIG0QBR2ASXB
          </ItemText>
          <CopyBox>
            <Image
              src="../../../wwwsite/images/copy.svg"
              cursor={"pointer"}
              onClick={() => {
                clickCopy("21");
              }}
            />
          </CopyBox>
        </ItemBox>
        <SecretKeyText>{t("ewrHdSoDPutFlPrqTEr")}</SecretKeyText>
      </Box>
      <Space />
      {/* API 权限 */}
      <Box w={"100%"}>
        <ItemBox>
          <ItemText>{t("ZZlJgALCrsSaNhaoV")}</ItemText>
          <ItemText fontWeight={600} textAlign={"right"}>
            {t("YmIZCYMTuGNvbocpiJOP")}
          </ItemText>
        </ItemBox>
      </Box>
      <Space />

      {/* IP访问限制 */}
      <Box w={"100%"}>
        <BXInput
          onChange={(e) => setIpAddressInputValue(e.target.value)}
          placeholder={t("请输入受信任的IP地址，多个地址用；隔开")}
        ></BXInput>
      </Box>
      <Space />

      <BXButton ml={"10px"} w={"70%"} className={btnDisabled ? "disabled" : ""}>
        {t("保存")}
      </BXButton>
    </Flex>
  );
};

export default Save;
